import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Body from './components/Body';
import Footer from './components/Footer';

function App() {
  return (
    <>
    <div className='main'>
    <Header/>
    <div className='container'>
    <Body/>
    </div>
    <Footer/>
    </div>
    </>
  );
}

export default App;
